import React from 'react';
import { Handle, Position } from 'reactflow';

const ScopeNode = ({ data }) => {
    return (
        <div style={{ padding: 10, border: '1px solid #fff', borderRadius: '5px', background: '#2a2a2a', color: '#fff' }}>
            {data.label}
            <Handle type="target" position={Position.Left} style={{ background: '#555' }} />
        </div>
    );
};

export default ScopeNode;
